import { GestorGrafica } from './graficaModulo.js';
import { mostrarToast, obtenerUrlBackend } from './utilerias.js';

let graficaNomina = null;
let modoGraficaNomina = 'datos';
let vistaGraficaNomina = 'entidad';
const URL_BASE_API = obtenerUrlBackend('8083');

export function paginaNomina() {

    const html = `
        <div class="container-fluid">

            <div class="card">

                <div class="
                            d-flex
                            justify-content-between
                            align-items-center">

                    <h5 class="mb-0">
                        <!--Gráfica -->
                    </h5>

                    <button
                        type="button"
                        class="btn btn-sm btn-outline-dark"
                        data-bs-toggle="modal"
                        data-bs-target="#modalParametrosNomina">

                        <i class="fa-solid fa-sliders me-1"></i>
                        Parámetros

                    </button>

                    <button
                        type="button"
                        class="btn btn-sm btn-outline-secondary"
                        id="btn-modo-grafica-nomina">
                        Datos
                    </button>

                </div>

                <div class="card-body">

                    <div style="height: 500px;">
                        <canvas id="nom-grafica"></canvas>
                    </div>

                </div>

            </div>


            <div
                class="modal fade"
                id="modalParametrosNomina"
                tabindex="-1">

                <div class="modal-dialog">

                    <div class="modal-content">

                        <div class="modal-header">

                            <h5 class="modal-title nomina-modal-titulo">
				<i class="fa-solid fa-sliders me-1"></i>
                                Parámetros
                            </h5>

                            <button
                                type="button"
                                class="btn-close"
                                data-bs-dismiss="modal">
                            </button>

                        </div>

                        <div class="modal-body">


<!-- PERIODO -->

<div class="nomina-periodo">

    <div class="nomina-seccion-titulo">
        Periodo
    </div>

    <div class="nomina-periodo-campos">

        <div class="nomina-periodo-campo">

            <label for="nom-fecha-inicio">
                Desde:
            </label>

            <input
                type="month"
                id="nom-fecha-inicio"
                class="form-control">

        </div>

        <div class="nomina-periodo-campo">

            <label for="nom-fecha-fin">
                Hasta:
            </label>

            <input
                type="month"
                id="nom-fecha-fin"
                class="form-control">

        </div>

    </div>

</div>

<!-- ENTIDAD -->

<div class="nomina-entidades">

    <div class="nomina-fila-opciones">

        <div class="nomina-seccion-titulo nomina-entidades-titulo">
            Entidad
        </div>

        <div
            id="nom-lista-entidades"
            class="nomina-entidades-opciones">

            <!-- dinámico -->

        </div>

    </div>

    <div class="nomina-fila-opciones nomina-fila-vista">

        <div class="nomina-seccion-titulo nomina-entidades-titulo">
            Mostrar datos por
        </div>

        <div class="nomina-vista-opciones">

            <div class="form-check form-check-inline">

                <input
                    class="form-check-input"
                    type="radio"
                    name="nom-vista-grafica"
                    id="nom-vista-entidad"
                    value="entidad"
                    checked>

                <label
                    class="form-check-label"
                    for="nom-vista-entidad">

                    Entidad

                </label>

            </div>

            <div class="form-check form-check-inline">

                <input
                    class="form-check-input"
                    type="radio"
                    name="nom-vista-grafica"
                    id="nom-vista-total"
                    value="total">

                <label
                    class="form-check-label"
                    for="nom-vista-total">

                    Total

                </label>

            </div>

        </div>

    </div>

</div>

<!-- CONCEPTOS -->

<div class="row nomina-conceptos-header">

    <div class="col-6 nomina-seccion-titulo">
        Concepto
    </div>

    <div class="col-3 text-center">
        Real
    </div>

    <div class="col-3 text-center">
        Promedio
    </div>

</div>

<div id="nom-lista-conceptos">
    <!-- dinámico -->
</div>


</div>
<!-- FIN modal-body -->


<div class="modal-footer nomina-modal-footer">

    <button
        type="button"
        class="btn btn-outline-secondary"
        id="btn-limpiar-nomina">

        Limpiar

    </button>

    <button
        type="button"
        class="btn btn-secondary"
        id="btn-graficar-nomina">

        Graficar

    </button>

</div>

                    </div>

                </div>

            </div>

        </div>
    `;

setTimeout(() => {

    graficaNomina = new GestorGrafica({
        idInicio: 'nom-fecha-inicio',
        idFin: 'nom-fecha-fin',
        idContenedorMetricas: 'nom-lista-conceptos',
        idCanvas: 'nom-grafica',
        storageKey: 'preferenciasGraficaNomina',
        selectorCheckboxes: '.nom-metrica-selector',
        posicionLeyenda: 'bottom',

        onLegendChange: async () => {
            await guardarEstadoActualNomina();
        }
    });

    // =====================================================
    // BOTÓN LIMPIAR
    // =====================================================

    const btnLimpiar =
    document.getElementById('btn-limpiar-nomina');

if (btnLimpiar) {

    btnLimpiar.addEventListener('click', () => {

        const inicio =
            document.getElementById('nom-fecha-inicio');

        const fin =
            document.getElementById('nom-fecha-fin');

        if (inicio) inicio.value = '';
        if (fin) fin.value = '';


        document
        .querySelectorAll('.nom-entidad-selector')
        .forEach(item => {
            item.checked = false;
        });

        const checkTodas =
        document.getElementById('nom-entidad-todas');

        if (checkTodas) {
            checkTodas.checked = false;
            checkTodas.indeterminate = false;
        }

        const radioEntidad =
        document.getElementById('nom-vista-entidad');

        if (radioEntidad) {
            radioEntidad.checked = true;
        }

        vistaGraficaNomina = 'entidad';


        document
            .querySelectorAll('.nom-metrica-selector')
            .forEach(item => {

                item.checked = false;

            });        

    });
}


    // =====================================================
    // BOTÓN GRAFICAR
    // =====================================================

    const btnGraficar =
        document.getElementById('btn-graficar-nomina');

    if (btnGraficar) {

        btnGraficar.addEventListener('click', async () => {

            await generarGraficaNomina();

        });

    }


    // =====================================================
    // BOTÓN DATOS / % VENTA
    // =====================================================

    const btnModo =
        document.getElementById('btn-modo-grafica-nomina');

    if (btnModo) {

        btnModo.addEventListener('click', async () => {

            modoGraficaNomina =
                modoGraficaNomina === 'datos'
                    ? 'porcentaje'
                    : 'datos';


            btnModo.textContent =
                modoGraficaNomina === 'datos'
                    ? 'Cambiar a %Venta'
                    : 'Cambiar a Datos';


            // Generamos nuevamente la gráfica
            // y guardamos el nuevo modo
            await generarGraficaNomina(true);

        });

    }


    // =====================================================
    // CARGAR CATÁLOGOS Y RESTAURAR PREFERENCIAS
    // =====================================================

    (async () => {

        await cargarCatalogosNomina();

        await restaurarPreferenciaNomina();

    })();


}, 100);

return html;
}

async function guardarEstadoActualNomina() {

    const fechaInicio =
        document.getElementById('nom-fecha-inicio')?.value;

    const fechaFin =
        document.getElementById('nom-fecha-fin')?.value;

    const entidadesSeleccionadas =
        Array.from(
            document.querySelectorAll(
                '.nom-entidad-selector:checked'
            )
        ).map(item => item.value);

    const radioVista =
    document.querySelector(
        'input[name="nom-vista-grafica"]:checked'
    );


vistaGraficaNomina =
    radioVista?.value === 'total'
        ? 'total'
        : 'entidad';

    const metricasSeleccionadas =
        Array.from(
            document.querySelectorAll(
                '.nom-metrica-selector:checked'
            )
        );

    await guardarPreferenciaNomina(
        fechaInicio,
        fechaFin,
        entidadesSeleccionadas,
        metricasSeleccionadas
    );
}

async function restaurarPreferenciaNomina() {

    try {

        const token =
            sessionStorage.getItem('token_teresita');

        const respuesta = await fetch(
            `${URL_BASE_API}/api/preferencias/nomina/ultima_grafica`,
            {
                method: 'GET',
                headers: {
                    'Authorization': token,
                    'Content-Type': 'application/json'
                }
            }
        );

        if (!respuesta.ok) {
            throw new Error(
                `Error al consultar preferencia: ${respuesta.status}`
            );
        }

        const resultado = await respuesta.json();

        if (
            !resultado.success ||
            !resultado.existe ||
            !resultado.valor
        ) {
            return;
        }

        const preferencias = resultado.valor;

        if (preferencias.modoGrafica) {
            modoGraficaNomina = preferencias.modoGrafica;
        }

        if (preferencias.vistaGrafica) {
            vistaGraficaNomina =
            preferencias.vistaGrafica === 'total'
            ? 'total'
            : 'entidad';
        }

        const btnModo =
        document.getElementById('btn-modo-grafica-nomina');

        if (btnModo) {
            btnModo.textContent =
                modoGraficaNomina === 'datos'
                    ? 'Cambiar a %Venta'
                    : 'Cambiar a Datos';
        }

        // ---------------------------------------------
        // RESTAURAR PERIODO
        // ---------------------------------------------

        const inicio =
            document.getElementById('nom-fecha-inicio');

        const fin =
            document.getElementById('nom-fecha-fin');

        if (inicio && preferencias.fechaInicio) {
            inicio.value = preferencias.fechaInicio;
        }

        if (fin && preferencias.fechaFin) {
            fin.value = preferencias.fechaFin;
        }


        // ---------------------------------------------
        // RESTAURAR ENTIDADES
        // ---------------------------------------------

        document
            .querySelectorAll('.nom-entidad-selector')
            .forEach(item => {

                item.checked =
                    preferencias.entidades?.includes(item.value) || false;
            });

            actualizarSeleccionTodasNomina();

            
            const radioVista =
            document.getElementById(
                vistaGraficaNomina === 'total'
                ? 'nom-vista-total'
                : 'nom-vista-entidad'
            );

            if (radioVista) {
                radioVista.checked = true;
            }


        // ---------------------------------------------
        // RESTAURAR MÉTRICAS
        // ---------------------------------------------

        document
            .querySelectorAll('.nom-metrica-selector')
            .forEach(item => {

                const concepto =
                    item.dataset.concepto;

                const tipo =
                    item.dataset.tipo;

                item.checked =
                    preferencias.metricas?.some(
                        metrica =>
                            metrica.concepto === concepto &&
                            metrica.tipo === tipo
                    ) || false;

            });


        // ---------------------------------------------
        // GENERAR AUTOMÁTICAMENTE LA ÚLTIMA GRÁFICA
        // ---------------------------------------------

        const metricasSeleccionadas =
            Array.from(
                document.querySelectorAll(
                    '.nom-metrica-selector:checked'
                )
            );

        if (
            preferencias.entidades?.length > 0 &&
            metricasSeleccionadas.length > 0 &&
            preferencias.fechaInicio &&
            preferencias.fechaFin
        ) {
            
            // Generar la gráfica guardada
            await generarGraficaNomina(false);
            
            
            // =====================================================
            // RESTAURAR SERIES OCULTAS
            // =====================================================
             
            if (
                preferencias.seriesOcultas?.length > 0 &&
                graficaNomina?.GraficaInstance
            ) {
                graficaNomina.GraficaInstance.data.datasets.forEach(
                    (dataset, index) => {
                        if (
                            preferencias.seriesOcultas.includes(
                                dataset.label
                            )
                        ) {
                            graficaNomina.GraficaInstance
                            .setDatasetVisibility(
                                index,
                                false
                            );
                        }
                    }
                );
                graficaNomina.GraficaInstance.update();
            }
        }
    
    } catch (error) {

        console.error(
            'Error al restaurar preferencias de Nómina:',
            error
        );

    }
}

async function generarGraficaNomina(guardarPreferencia = true) {
    

    try {

        const fechaInicio =
            document.getElementById('nom-fecha-inicio')?.value;

        const fechaFin =
            document.getElementById('nom-fecha-fin')?.value;


        const entidadesSeleccionadas =
            Array.from(
                document.querySelectorAll(
                    '.nom-entidad-selector:checked'
                )
            ).map(item => item.value);

        const radioVista =
    document.querySelector(
        'input[name="nom-vista-grafica"]:checked'
    );


vistaGraficaNomina =
    radioVista?.value === 'total'
        ? 'total'
        : 'entidad';


        const metricasSeleccionadas =
            Array.from(
                document.querySelectorAll(
                    '.nom-metrica-selector:checked'
                )
            );


        if (!fechaInicio || !fechaFin) {

            mostrarToast(
                'Selecciona el periodo.',
                'warning'
            );

            return;
        }


        if (entidadesSeleccionadas.length === 0) {

            mostrarToast(
                'Selecciona al menos una entidad.',
                'warning'
            );

            return;
        }


        if (metricasSeleccionadas.length === 0) {

            mostrarToast(
                'Selecciona al menos un concepto.',
                'warning'
            );

            return;
        }


        const conceptos = [
            ...new Set(
                metricasSeleccionadas.map(
                    item => item.dataset.concepto
                )
            )
        ];

        const parametros = new URLSearchParams();

        parametros.set(
            'entidades',
            entidadesSeleccionadas.join(',')
        );

        parametros.set(
            'conceptos',
            conceptos.join(',')
        );

        parametros.set(
            'tipo',
            modoGraficaNomina
        );

        parametros.set(
            'vista',
            vistaGraficaNomina
        );


        const token =
            sessionStorage.getItem('token_teresita');


        const respuesta = await fetch(
            `${URL_BASE_API}/api/nomina/datos?${parametros.toString()}`,
            {
                method: 'GET',
                headers: {
                    'Authorization': token,
                    'Content-Type': 'application/json'
                }
            }
        );


        if (!respuesta.ok) {

            throw new Error(
                `Error al consultar datos: ${respuesta.status}`
            );

        }


        const datos = await respuesta.json();


        if (!datos || datos.length === 0) {

            mostrarToast(
                'No hay datos para los parámetros seleccionados.',
                'warning'
            );

            return;
        }

        prepararGraficaNomina(
            datos,
            metricasSeleccionadas,
            entidadesSeleccionadas,
            fechaInicio,
            fechaFin
        );

        if (guardarPreferencia) {
            await guardarPreferenciaNomina(
                fechaInicio,
                fechaFin,
                entidadesSeleccionadas,
                metricasSeleccionadas
            );
        }


    } catch (error) {

        console.error(
            'Error al generar gráfica de Nómina:',
            error
        );

        mostrarToast(
            error.message,
            'warning'
        );

    }

}

function prepararGraficaNomina(
    datos,
    metricasSeleccionadas,
    entidades,
    fechaInicio,
    fechaFin
) {

const nombresMetricas = [];


// =====================================================
// TEXTO DE ENTIDADES PARA LA LEYENDA
// =====================================================

const textoEntidadesTotal =
    entidades.join('+');


const entidadesGrafica =
    vistaGraficaNomina === 'total'
        ? [textoEntidadesTotal]
        : entidades;


// =====================================================
// EN MODO TOTAL, EL BACKEND DEVUELVE:
// TOTAL CONCEPTO Real
//
// Cambiamos únicamente el nombre para presentación:
// MX+SL CONCEPTO Real
// =====================================================

if (vistaGraficaNomina === 'total') {

    datos = datos.map(fila => {

        return {
            ...fila,

            nombre_campo:
                fila.nombre_campo.replace(
                    /^TOTAL /,
                    `${textoEntidadesTotal} `
                )
        };

    });

}


// =====================================================
// CONSTRUIR NOMBRES DE SERIES
// =====================================================

entidadesGrafica.forEach(entidad => {

    metricasSeleccionadas.forEach(item => {

        const concepto =
            item.dataset.concepto;

        const tipo =
            item.dataset.tipo;

        const textoModo =
            modoGraficaNomina === 'porcentaje'
                ? ' % Venta'
                : '';


        nombresMetricas.push(
            `${entidad} ${concepto}${textoModo} ${tipo}`
        );

    });

});

    graficaNomina.datosGlobales = datos;

    const inicio =
        document.getElementById('nom-fecha-inicio');

    const fin =
        document.getElementById('nom-fecha-fin');

    if (inicio) {
        inicio.value = fechaInicio;
    }

    if (fin) {
        fin.value = fechaFin;
    }

    const [anioI, mesI] =
        fechaInicio.split('-').map(Number);

    const [anioF, mesF] =
        fechaFin.split('-').map(Number);

    const fechaDesde =
        new Date(anioI, mesI - 1, 1);

    const fechaHasta =
        new Date(anioF, mesF - 1, 1);

    graficaNomina.dibujarGraficaPorRango(
        nombresMetricas,
        fechaDesde,
        fechaHasta
    );

    const modalElemento =
        document.getElementById(
            'modalParametrosNomina'
        );

    if (modalElemento) {
        
        const modal =
        bootstrap.Modal.getInstance(
            modalElemento
        );
    
        if (modal) {
            // Quitar el foco del botón dentro del modal
            if (document.activeElement instanceof HTMLElement) {
                document.activeElement.blur();
            }
            modal.hide();
        }
    }
}

async function guardarPreferenciaNomina(
    fechaInicio,
    fechaFin,
    entidades,
    metricasSeleccionadas
    
) {

    try {

        const token =
            sessionStorage.getItem('token_teresita');

        const metricas = metricasSeleccionadas.map(item => ({
            concepto: item.dataset.concepto,
            tipo: item.dataset.tipo
        }));

        const seriesOcultas = [];
        if (graficaNomina?.GraficaInstance) {
            graficaNomina.GraficaInstance.data.datasets.forEach(
                (dataset, index) => {
                    if (
                        !graficaNomina.GraficaInstance
                        .isDatasetVisible(index)
                    ) {
                        seriesOcultas.push(dataset.label);
                    }
                }
            );
        }

        const respuesta = await fetch(
            `${URL_BASE_API}/api/preferencias/nomina/ultima_grafica`,
            {
                method: 'PUT',
                headers: {
                    'Authorization': token,
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    valor: {
                        fechaInicio,
                        fechaFin,
                        entidades,
                        metricas,
                        modoGrafica: modoGraficaNomina,
                        vistaGrafica: vistaGraficaNomina,
                        seriesOcultas
                    }
                })
            }
        );

        if (!respuesta.ok) {
            throw new Error(
                `Error al guardar preferencia: ${respuesta.status}`
            );
        }

    } catch (error) {

        console.error(
            'Error al guardar preferencias de Nómina:',
            error
        );

    }
}

async function cargarCatalogosNomina() {

    try {

        const token = sessionStorage.getItem('token_teresita');

        const respuesta = await fetch(
            `${URL_BASE_API}/api/nomina/catalogos`,
            {
                method: 'GET',
                headers: {
                    'Authorization': token,
                    'Content-Type': 'application/json'
                }
            }
        );

        if (!respuesta.ok) {
            throw new Error(
                `Error al cargar catálogos: ${respuesta.status}`
            );
        }

        const datos = await respuesta.json();

        renderizarEntidades(datos.entidades || []);
        renderizarConceptos(datos.conceptos || []);

        configurarPeriodo(datos.anios || []);

    } catch (error) {

        console.error(
            'Error al cargar catálogos de Nómina:',
            error
        );

        mostrarToast(
            'No fue posible cargar los parámetros de Nómina.',
            'warning'
        );
    }
}

function renderizarEntidades(entidades) {

    const contenedor =
        document.getElementById('nom-lista-entidades');

    if (!contenedor) return;


    const htmlEntidades =
        entidades.map(item => {

            const entidad = item.entidad;

            return `
                <div class="form-check form-check-inline">

                    <input
                        class="form-check-input nom-entidad-selector"
                        type="checkbox"
                        value="${entidad}"
                        id="nom-entidad-${entidad}">

                    <label
                        class="form-check-label"
                        for="nom-entidad-${entidad}">

                        ${entidad}

                    </label>

                </div>
            `;

        }).join('');


    const htmlTodas = `

        <div class="form-check form-check-inline">

            <input
                class="form-check-input"
                type="checkbox"
                id="nom-entidad-todas">

            <label
                class="form-check-label"
                for="nom-entidad-todas">

                Seleccionar todas

            </label>

        </div>

    `;


    contenedor.innerHTML =
        htmlEntidades +
        htmlTodas;


    // =====================================================
    // SELECCIONAR TODAS
    // =====================================================

    const checkTodas =
        document.getElementById('nom-entidad-todas');

    const entidadesCheckbox =
        Array.from(
            document.querySelectorAll('.nom-entidad-selector')
        );


    if (checkTodas) {

        checkTodas.addEventListener('change', () => {

            entidadesCheckbox.forEach(item => {

                item.checked =
                    checkTodas.checked;

            });

            checkTodas.indeterminate = false;

        });

    }


    // =====================================================
    // ACTUALIZAR ESTADO DEL CHECK "TODAS"
    // =====================================================

    entidadesCheckbox.forEach(item => {

        item.addEventListener('change', () => {

            actualizarSeleccionTodasNomina();

        });

    });

}

function actualizarSeleccionTodasNomina() {

    const checkTodas =
        document.getElementById('nom-entidad-todas');

    if (!checkTodas) return;


    const entidades =
        Array.from(
            document.querySelectorAll('.nom-entidad-selector')
        );


    if (entidades.length === 0) {

        checkTodas.checked = false;
        checkTodas.indeterminate = false;

        return;
    }


    const seleccionadas =
        entidades.filter(item => item.checked);


    checkTodas.checked =
        seleccionadas.length === entidades.length;


    checkTodas.indeterminate =
        seleccionadas.length > 0 &&
        seleccionadas.length < entidades.length;
}

function renderizarConceptos(conceptos) {

    const contenedor =
        document.getElementById('nom-lista-conceptos');

    if (!contenedor) return;

    contenedor.innerHTML = conceptos.map(item => {

        const concepto = item.concepto;
        const numero = item.numero;

        return `
            <div class="row align-items-center nomina-concepto-fila">

                <div class="col-6">
                    ${concepto}
                </div>

                <div class="col-3 text-center">

                    <input
                        class="form-check-input nom-metrica-selector"
                        type="checkbox"
                        data-concepto="${concepto}"
                        data-tipo="Real"
                        value="${concepto} Real"
                        id="nom-real-${numero}">

                </div>

                <div class="col-3 text-center">

                    <input
                        class="form-check-input nom-metrica-selector"
                        type="checkbox"
                        data-concepto="${concepto}"
                        data-tipo="Promedio"
                        value="${concepto} Promedio"
                        id="nom-prom-${numero}">

                </div>

            </div>
        `;

    }).join('');
}

function configurarPeriodo(anios) {

    if (!anios || anios.length === 0) return;

    const valores = anios.map(item => Number(item.anio));

    const minAnio = Math.min(...valores);
    const maxAnio = Math.max(...valores);

    const inicio =
        document.getElementById('nom-fecha-inicio');

    const fin =
        document.getElementById('nom-fecha-fin');

    if (inicio && !inicio.value) {
        inicio.value = `${minAnio}-01`;
    }

    if (fin && !fin.value) {
        fin.value = `${maxAnio}-12`;
    }
}


